import { InMemoryCache } from "@apollo/client";

export const inMemoryCache = new InMemoryCache({});
